import { Badge } from '@mantine/core';

interface RescheduleRequestStatusProps {
  decision?: 'accept' | 'deny';
  /** When true and no decision yet, shows awaiting-provider state (client view). */
  pending?: boolean;
}

/**
 * Read-only reschedule outcome / pending state shown on the structured request card.
 */
export function RescheduleRequestStatus({
  decision,
  pending = false,
}: RescheduleRequestStatusProps): JSX.Element | null {
  if (decision === 'accept') {
    return (
      <Badge variant="light" color="green" size="sm" mt="md" style={{ maxWidth: '100%', whiteSpace: 'normal', height: 'auto' }}>
        Accepted by provider
      </Badge>
    );
  }

  if (decision === 'deny') {
    return (
      <Badge variant="light" color="red" size="sm" mt="md" style={{ maxWidth: '100%', whiteSpace: 'normal', height: 'auto' }}>
        Declined by provider
      </Badge>
    );
  }

  if (pending) {
    return (
      <Badge variant="light" color="yellow" size="sm" mt="md" style={{ maxWidth: '100%', whiteSpace: 'normal', height: 'auto' }}>
        Awaiting provider response
      </Badge>
    );
  }

  return null;
}
